import { concat, fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';

export interface DatePickerOptionsComponentSignature {
  Args: {
    options?: string[];
    selectedOption?: string;
    highlightedOption: string | null;
    dropdownId?: string;
    highlightedIndex?: number;
    onOptionSelect?: (option: string, close?: () => void) => void;
    onListboxFocus: (event: FocusEvent) => void;
    close?: () => void;
  };
  Element: HTMLUListElement;
}

export default class DatePickerOptionsComponent extends Component<DatePickerOptionsComponentSignature> {
  @action
  selectOption(option: string): void {
    this.args.onOptionSelect?.(option, this.args.close);
  }

  <template>
    <ul
      role="listbox"
      tabindex="0"
      aria-activedescendant={{if @dropdownId (concat @dropdownId "-" @highlightedIndex)}}
      class="ember-power-select-options !max-h-none"
      data-test-date-picker-options-list
      id={{concat @dropdownId "-listbox"}}
      {{on "focus" @onListboxFocus}}
    >
      {{#each @options as |option idx|}}
        <li
          id={{concat @dropdownId "-" idx}}
          class="ember-power-select-option envoy-date-picker-options-option"
          aria-selected={{if (eq option @selectedOption) "true" "false"}}
          aria-current={{if (eq option @highlightedOption) "true" "false"}}
          data-option-index={{idx}}
          role="option"
          data-test-date-picker-options-shortcut={{option}}
          data-test-date-picker-options-option
          {{on "click" (fn this.selectOption option)}}
        >
          {{option}}
        </li>
      {{/each}}
    </ul>
  </template>
}
